/**
 *
 *  System constants
 *
 *    All messages go through the portal route
 *
 *
 *
 *
 *
 *
 */

 const portalRoot = (process.env.NODE_ENV === "development")
   ? 'http://localhost:9040/portal'
   : 'https://api2.icare.cafe/portal';

 export default  {
  API_KEY:  'SGjQSIdvPVD1Ylzv1TTsgNnLoRwVVAGs',
  INTEGRATION_TYPE: 'donations-express',
  PORTAL_API_ROOT: portalRoot,
  PORTAL_APIURL: `${portalRoot}/1`
  // PORTAL_APIURL: (process.env.NODE_ENV === "development") ? 'http://sandbox.ioihan.com:9040/portal/1'  : 'https://api.icare.cafe/portal/1'
  // PORTAL_APIURL: (process.env.NODE_ENV === "development") ? 'http://127dev.link:9040/portal/1'  : 'https://api.icare.cafe/portal/1'
}

